// Determine if we are in a App View
export default function () { // eslint-disable-line func-names
  const params = new URLSearchParams(window.location.search); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
  if (
    '1' === params.get('disableHeader')
    && '1' === params.get('disableFooter')
    && 'app' === params.get('ref')
  ) {
    return true;
  }
  return false;
}
